import React from "react";
import Seo from "../../../shared/ui/Seo";

const ReturnAndRefundPolicy = () => {
  return (
    <div className="container container-lg py-24">
      <Seo
        title="Return & Refund Policy"
        description="Bigmall's return and refund policy explains how to return products and request refunds or exchanges for orders placed on our Sri Lankan online store."
      />
      <h1 className="page-title">Return and Refund Policy</h1>

      {/* ORDER WARRANTY CLAIMS */}
      <section className="mb-5">
        <h6 className="fw-bold mb-3">ORDER WARRANTY CLAIMS</h6>
        <p>
          As Bigmall operates with a noted Disclaimer of Warranty, we pledge to honor our assertion as per stated guarantee claims on products clearly noted in the respective descriptions. Buyers can claim warranties and guarantees that are explicitly indicated from a product description within its terms and circumstances if the product description states them.
        </p>
      </section>

      {/* WARRANTY ADHERENCES */}
      <section className="mb-5">
        <h6 className="fw-bold mb-3">WARRANTY ADHERENCES</h6>
        <p>
          Where a product’s description includes some guarantees and warranty terms, the buyers should conduct an in-depth research of coverage length, conditions for making claims etc. These guarantees are fully adhered to by Bigmall.
        </p>
      </section>

      {/* Duration and Limits */}
      <section className="mb-5">
        <h6 className="fw-semibold mb-2">Duration and Limits</h6>
        <p>
          It is essential to note that some warranties noted under product descriptions are specific to product features and might include limitations or exceptions. Reading the terms and conditions provided on the product description helps determine the scope and application involved with other warranties/guarantees issued by that particular company.
        </p>
      </section>

      {/* Problem Resolution */}
      <section className="mb-5">
        <h6 className="fw-semibold mb-2">Problem Resolution</h6>
        <p>
          In case of any issues or discrepancies with warranty claims, customers are advised to contact Bigmall customer service for assistance or compensation. We strive to address customer difficulties in the fairest possible way.
        </p>
      </section>
    </div>
  );
};

export default ReturnAndRefundPolicy;
